<script>
import PedalKnob from '../PedalKnob.vue';
import CcBadge from '../CcBadge.vue';

export default {
  components: { PedalKnob, CcBadge },

  inject: {
    capabilities: { default: () => ({ capabilities: {} }) }
  },

  props: {
    effect: {
      type: Object,
      required: true
    }
  },

  computed: {
    beatAffinitySupported() {
      return this.capabilities?.capabilities?.glitch?.beat_affinity === true;
    }
  }
}
</script>
<template>
  <div class="pedal-knobs">
    <CcBadge :effect="effect" param="min">
      <PedalKnob
        label="Min"
        tip="Minimum CC value that Glitch can output."
        :value="effect.min ?? 0"
        @update:value="v => effect.min = v"
        />
    </CcBadge>
    <CcBadge :effect="effect" param="max">
      <PedalKnob
        label="Max"
        tip="Maximum CC value that Glitch can output."
        :value="effect.max ?? 127"
        @update:value="v => effect.max = v"
        />
    </CcBadge>
    <CcBadge :effect="effect" param="focus">
      <PedalKnob
        label="Focus"
        tip="At 100, only Min and Max are possible — binary switching. At 0, any value between Min and Max can be output."
        :max="100"
        :snaps="[25, 50, 75]"
        :value="effect.focus ?? 100"
        @update:value="v => effect.focus = v"
        />
    </CcBadge>
    <CcBadge :effect="effect" param="spread">
      <PedalKnob
        label="Spread"
        tip="Shapes probability distribution symmetrically. Positive values concentrate output toward Min and Max; negative values concentrate output toward the midpoint."
        mode="bipolar"
        :value="effect.spread ?? 0"
        @update:value="v => effect.spread = v"
        />
    </CcBadge>
    <CcBadge :effect="effect" param="bias">
      <PedalKnob
        label="Bias"
        tip="Shifts the probability distribution directionally. Negative favours lower values; positive favours higher values."
        mode="bipolar"
        :value="effect.bias ?? 0"
        @update:value="v => effect.bias = v"
        />
    </CcBadge>
    <CcBadge
      v-if="beatAffinitySupported && effect.clock_sync"
      :effect="effect"
      param="beat_affinity"
    >
      <PedalKnob
        label="Beat Affinity"
        tip="Biases glitch timing toward or away from beat positions. Positive values cluster events near beats; negative values push them into the gaps between beats."
        mode="bipolar"
        :value="effect.beat_affinity ?? 0"
        @update:value="v => effect.beat_affinity = v"
        />
    </CcBadge>
  </div>
</template>
